import React from "react";
import { TimeUnit } from "components/common";
const DnsAdapterSummary = ({ dataAdapter }) => {
  const { config } = dataAdapter;
  const lookupType = {
    A: "Resolve hostname to IPv4 address (A)",
    AAAA: "Resolve hostname to IPv6 address (AAAA)",
    A_AAAA: "Resolve hostname to IPv4 and IPv6 address (A and AAAA)",
    PTR: "Reverse lookup (PTR)",
    TXT: "Text lookup (TXT)"
  };
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "DNS Lookup Type"), /* @__PURE__ */ React.createElement("dd", null, lookupType[config.lookup_type]), /* @__PURE__ */ React.createElement("dt", null, "DNS Server IP Address"), /* @__PURE__ */ React.createElement("dd", null, config.server_ips || "n/a"), /* @__PURE__ */ React.createElement("dt", null, "DNS Request Timeout"), /* @__PURE__ */ React.createElement("dd", null, config.request_timeout, " ms"), /* @__PURE__ */ React.createElement("dt", null, "Cache TTL Override"), /* @__PURE__ */ React.createElement("dd", null, !config.cache_ttl_override_enabled ? "n/a" : /* @__PURE__ */ React.createElement(TimeUnit, { value: config.cache_ttl_override, unit: config.cache_ttl_override_unit })));
};
export default DnsAdapterSummary;
